import { StateCreator } from 'zustand';
import {
  ConversationsCreateSlice,
  ConversationsCreateSliceState,
} from './index.types';

const initialState: ConversationsCreateSliceState = {
  isCreatingNewConversation: false,
  isLoading: false,
  isError: false,
  contactOptions: [],
  selectedContacts: [],
  nextPageUrl: null,
  hasMore: false,
  previewConversationId: null,
  isAdHocGroupCreation: false,
};

export const createConversationsCreateSlice: StateCreator<
  ConversationsCreateSlice
> = (set, get) => ({
  ...initialState,
  setIsCreatingNewConversation: (isCreatingNewConversation) => set({ isCreatingNewConversation }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setIsError: (isError) => set({ isError }),
  setContactOptions: (contactOptions) => set({ contactOptions }),
  setSelectedContacts: (selectedContacts) => {
    const currentState = get();
    const previousContacts = currentState.selectedContacts;

    if (selectedContacts.length > previousContacts.length) {
      const newContacts = selectedContacts.filter(
        contact => !previousContacts.some(prev => prev.value === contact.value)
      );

      newContacts.forEach(contact => {
        currentState.onContactAdded?.(contact);
      });
    }

    set({ selectedContacts });
  },
  setNextPageUrl: (nextPageUrl) => set({ nextPageUrl }),
  setHasMore: (hasMore) => set({ hasMore }),
  setOnContactAdded: (onContactAdded) => set({ onContactAdded }),
  setPreviewConversationId: (previewConversationId) => set({ previewConversationId }),
  setIsAdHocGroupCreation: (isAdHocGroupCreation) => set({ isAdHocGroupCreation }),
  resetAutocomplete: () => {
    set(initialState);
  },
});
